var map = {
	"./icon-bathroom.svg": "bc1c",
	"./icon-bedroom.svg": "12e9",
	"./icon-car.svg": "6531",
	"./icon-carspace.svg": "dd6a",
	"./icon-checkmark.svg": "9b69",
	"./icon-circled-arrow.svg": "0674",
	"./icon-clothing.svg": "3714",
	"./icon-edit.svg": "140f",
	"./icon-groceries.svg": "312f",
	"./icon-holiday.svg": "05c4",
	"./icon-housing.svg": "5f0c",
	"./icon-location.svg": "e4d4",
	"./icon-needle.svg": "1de0",
	"./icon-other-costs.svg": "a493",
	"./icon-social-life.svg": "44c7",
	"./icon-star-empty.svg": "75a0",
	"./icon-star-filled.svg": "90d5",
	"./icon-tag.svg": "dc05",
	"./icon-tooltip.svg": "b19c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8132";